/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

export enum UnitStatReportClaimStatusEnum {
  OPEN = 'Open',
  CLOSED = 'Closed',
  REOPENED = 'Reopened',
  RESERVED = 'Reserved',
  OPEN_NO_PAY = 'OpenNoPay',
  MED_ONLY = 'MedOnly',
  INVALID = 'Invalid',
  MISSING_ENUM = 'MissingEnum',
}
